import type { FunctionComponent, HTMLProps } from 'react';
import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
    root: {
        color: theme.bino.color.primary,
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
}));
export type SpanLinkProps = HTMLProps<HTMLSpanElement> & {};
const SpanLink: FunctionComponent<SpanLinkProps> = ({
    children,
    className,
    ...props
}) => {
    const { classes, cx } = useStyles();
    return (
        <span className={cx(classes.root, className)} {...props}>
            {children}
        </span>
    );
};

export default SpanLink;
